export const isCoordinateString = (value) => /^\s*[+-]?\d+(?:\.\d+)?\s*,\s*[+-]?\d+(?:\.\d+)?\s*$/.test(String(value || ""));

export const hasStoreAddress = (address) => address && typeof address === "object" &&
  ["building", "street", "area", "city", "wilayat", "governorate"].some((key) => String(address[key] || "").trim());

export const formatAddressLocation = (address) => {
  if (!hasStoreAddress(address)) return "—";
  return [...new Set([address.building, address.street, address.area, address.city,
    address.wilayat, address.governorate, address.country]
    .map((value) => String(value || "").trim()).filter(Boolean))].join(", ");
};

// API coordinate serialization can round the map's numeric values.
export const sameStoreCoordinates = (left, right) => ["latitude", "longitude"].every((key) =>
  left?.[key] != null && right?.[key] != null &&
  Number.isFinite(Number(left[key])) && Number.isFinite(Number(right[key])) &&
  Math.abs(Number(left[key]) - Number(right[key])) < 0.000001);

export const matchesSavedStore = (item, saved) => Boolean(saved) &&
  ((item?.id != null && saved?.id != null && Number(item.id) === Number(saved.id)) ||
   (sameStoreCoordinates(item, saved) &&
    String(item?.storeName ?? item?.name ?? "").trim() === String(saved?.storeName ?? saved?.name ?? "").trim()));

export const savedStoreDetails = (item, cached, submitted) => {
  if (matchesSavedStore(item, submitted)) return submitted;
  return sameStoreCoordinates(item, cached) ? cached : {};
};

const addressKeys = ["governorate", "wilayat", "city", "area", "street", "building", "postalCode", "country", "countryCode"];
export const completeStoreAddress = (address) => addressKeys.filter((key) => !["postalCode", "countryCode"].includes(key))
  .every((key) => String(address?.[key] || "").trim());

// Only fill missing fields from a lookup of the same selected coordinates.
export const fillMissingAddressFields = (primary, fallback) => Object.fromEntries(
  addressKeys.map((key) => [key, String(primary?.[key] || "").trim() || fallback?.[key] || ""]));

export const normalizeStoreStatus = (value) => {
  if (value == null) return "active";
  if (typeof value === "boolean") return value ? "active" : "inactive";
  const s = String(value).trim().toLowerCase();
  return s === "inactive" || s === "false" || s === "0" ? "inactive" : "active";
};

export const isStoreActive = (value) => normalizeStoreStatus(value) === "active";

